export const PRICING = ['free', 'budget', 'mid', 'premium'];

export const lookupPricingLabels = (price: string) => {
    if (price === 'mid') {
        return 'Mid-Market'
    }
    return price.charAt(0).toUpperCase() + price.substring(1);
};